// const wcagFont = document.getElementById('AA');
// const wcagContrast = document.getElementById('contrast');
const body = document.querySelector('html');

$(document).ready(function () {

//    loadPageSetFont();
    loadPageSetContrast();

//    $('.czcionka--aaa').on('click', function() {
//        setClassHtml('size-2', 'size-0', 'size-1');
//        setLocalFont('size-2');
//    })
//    $('.czcionka--aa').on('click', function() {
//        setClassHtml('size-1', 'size-0', 'size-2');
//        setLocalFont('size-1');
//    })
//    $('.czcionka--a').on('click', function() {
//        setClassHtml('size-0', 'size-2', 'size-1');
//        setLocalFont('size-0');
//    })


    $('.kontrast_3').on('click', function() {
        setKontarst('highcontrast', 'normalcontrast');
        setLocalContrast('highcontrast');
    })
    $('.kontrast_2').on('click', function() {
        setKontarst('normalcontrast', 'highcontrast');
        setLocalContrast('normalcontrast');
    })
    $('.kontrast_1').on('click', function() {
        setKontarst('normal', 'normalcontrast', 'highcontrast');
        setLocalContrast('normal');
    })
})

//function setLocalFont(text) {
//    localStorage.setItem('font', text);
//}
function setLocalContrast(text) {
    localStorage.setItem('contrast', text);
}

//function loadPageSetFont() {
//    const checkFonts = localStorage.getItem('font');
//    if (checkFonts) {
//        setClassHtml(checkFonts);
//    }
//}
function loadPageSetContrast() {
    const contrast = localStorage.getItem('contrast');
    if (contrast) {
        setKontarst(contrast);
    }
}

function setClassHtml(clas , removeClas=null, removeClas_2=null) {
    body.classList.remove(removeClas, removeClas_2);
    body.classList.add(clas);
}


function setKontarst(clas, removeClas=null, removeClas_2=null) {
    body.classList.remove(removeClas, removeClas_2);
    body.classList.add(clas);
}
// fontsW(wcagFont);
// contrast(wcagContrast);

// function fontsW(wFonts) {
//     const checkFonts = localStorage.getItem('font');
//     body.classList.add('size-' + checkFonts);
//     let fontsize = checkFonts;
//     wFonts.addEventListener('click', function (ev) {
//         if (checkFonts) {
//             body.classList.remove('size-' + checkFonts);
//         }
//         ev.preventDefault();
//         if (fontsize < 2) {
//             fontsize++;
//         } else {
//             body.classList.remove('size-2');
//             fontsize = 0;
//         }
//         body.classList.remove('size-0', 'size-1');
//         body.classList.add('size-' + fontsize);
//         localStorage.setItem('font', fontsize);
//     });
// }

function contrast(contrastButton) {

    const check = localStorage.getItem('active');
    if (check) body.classList.add('highcontrast');
    contrastButton.addEventListener('click', function () {
        body.classList.toggle('highcontrast');
        if (body.classList.contains('highcontrast')) {
            let active = true;
            localStorage.setItem('active', active);
        } else {
            localStorage.removeItem('active');
        }
    });
}
